import { ContactState } from "../interfaces/contacts"
import { HolidayState } from "../interfaces/holiday"
import { Types } from "../types"
import { CalendarHolidayActions } from "../types/CalendarHolidy/actionType"
import { ContactActions } from "../types/contacts/actionsType"

const initialState: HolidayState = {

    getHolidayPending: false,
    holidays: null,
    addHolidayPending: false,
    addHolidaySuccess: false,
    updateHolidayPending: false,
    updateHolidaySuccess: false,
    removeHolidayPending: false,
    removeHolidaySuccess: false,

}


const calendarHoliday = (state = initialState, action: CalendarHolidayActions, response: any) => {

    switch (action.type) {

        case Types.GET_HOLIDAY_REQUEST:
            return {
                ...state,
                getHolidayPending: true,
                getHolidayError: null,

            }
        case Types.GET_HOLIDAY_SUCCESS:

            return {
                ...state,
                getHolidayPending: false,
                holidays: action.response

            }

        case Types.GET_HOLIDAY_ERROR:

            return {
                ...state,
                getHolidayPending: false,
                getHolidayError: action.payload
            }

        case Types.ADD_HOLIDAY_REQUEST:
            return {
                ...state,
                addHolidayPending: true,
                addHolidaySuccess: false,

                addHolidayError: null,

            }
        case Types.ADD_HOLIDAY_SUCCESS:

            return {
                ...state,
                addHolidayPending: false,
                addHolidaySuccess: true,

            }

        case Types.ADD_HOLIDAY_ERROR:

            return {
                ...state,
                addHolidayPending: false,
                addHolidayError: action.payload
            }

        case Types.UPDATE_HOLIDAY_REQUEST:
            return {
                ...state,
                updateHolidayPending: true,
                updateHolidaySuccess: false,

                updateHolidayError: null,

            }
        case Types.UPDATE_HOLIDAY_SUCCESS:

            return {
                ...state,
                updateHolidayPending: false,
                updateHolidaySuccess: true,

            }

        case Types.UPDATE_HOLIDAY_ERROR:

            return {
                ...state,
                updateHolidayPending: false,
                updateHolidayError: action.payload
            }



        case Types.REMOVE_HOLIDAY_REQUEST:
            return {
                ...state,
                removeHolidayPending: true,
                removeHolidaySuccess: false,
                removeHolidayError: null,

            }
        case Types.REMOVE_HOLIDAY_SUCCESS:

            return {
                ...state,
                removeHolidayPending: false,
                removeHolidaySuccess: true,

            }

        case Types.REMOVE_HOLIDAY_ERROR:

            return {
                ...state,
                removeHolidayPending: false,
                removeHolidayError: action.payload
            }




        case Types.RESET_HOLIDAY_PROPS:

            return {
                ...state,

                addHolidayPending: false,
                addHolidaySuccess: false,
                updateHolidayPending: false,
                updateHolidaySuccess: false,
                removeHolidayPending: false,
                removeHolidaySuccess: false,

            }





        default:
            return {
                ...state
            }
    }
}

export default calendarHoliday